var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAzureLicensesSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.85
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 2.667,
    x: 6.667,
    y: 0.333,
    rx: 0.333
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 2.667,
    x: 13,
    y: 13,
    rx: 0.333
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 2.667,
    x: 0.333,
    y: 13,
    rx: 0.333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.192 3L13.611 13M2.389 13L7.808 3M13 14.333L3 14.333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureLicensesSmall);
export default __webpack_public_path__ + "static/media/azure-licenses-small.44d83ffdfd04b734251e6105d9bdf8f2.svg";
export { ForwardRef as ReactComponent };